import PlanningApp from "@/vue/planning/App.vue"
import ClubAdvantagesApp from "@/vue/club-advantages/App.vue"
import ResidenceGallery from "@/vue/residence-gallery/App.vue"
import TrainBanner from "@/vue/train-banner/App.vue"

export default class AppInitializer {
	// singleton pattern
	#planningApp
	#mainMapApp
	#stationDomainMap
	#reviewApp
	#clubAdvantagesApp
	#residenceGallery
	#trainBanner

	constructor() {
		if (AppInitializer.singleton) {
			return AppInitializer.singleton
		}

		this.#planningApp = null
		this.#mainMapApp = null
		this.#stationDomainMap = null
		this.#reviewApp = null
		this.#clubAdvantagesApp = null
		this.#residenceGallery = null
		this.#trainBanner = null

		AppInitializer.singleton = this
		return AppInitializer.singleton
	}

	get planningApp() {
		return this.#planningApp
	}
	get mainMapApp() {
		return this.#mainMapApp
	}
	get stationDomainMap() {
		return this.#stationDomainMap
	}
	get reviewApp() {
		return this.#reviewApp
	}
	get clubAdvantagesApp() {
		return this.#clubAdvantagesApp
	}

	get residenceGallery() {
		return this.#residenceGallery
	}

	get trainBanner() {
		return this.#trainBanner
	}

	isAllAppsInitialized() {
		if (
			!this.#planningApp ||
			!this.#mainMapApp ||
			!this.#stationDomainMap ||
			!this.#reviewApp ||
			!this.#clubAdvantagesApp ||
			!this.#residenceGallery ||
			!this.#trainBanner
		)
			return false
		return true
	}

	async initPlanningApp(keyUpdater) {
		if (this.#planningApp) return
		// console.log(`initPlanningApp`)
		this.#planningApp = new Vue({
			name: "Planner App",
			render: (h) => h(PlanningApp),
			data: {},
			props: {
				keyUpdater,
			},
		})
		this.#planningApp.$mount("#planner-app")
		// window.vueApp = this.#planningApp
	}

	forceAppReInit(appName) {
		switch (appName) {
			case "planning":
				this.#planningApp.$destroy()
				this.#planningApp = null
				this.initPlanningApp()
				break
			default:
				throw new Error("other app reinit not implemented")
		}
	}

	async initMainMapApp() {
		if (this.#mainMapApp) return
		// console.log(`initMainMapApp`);

		const MapApp = await window.moduleLoader.getMapApp()

		this.#mainMapApp = new Vue({
			name: "Map App",
			render: (h) => h(MapApp),
			data: {},
		})
		this.#mainMapApp.$mount("#tf-map--wrapper")
	}

	async initStationDomainApp() {
		if (this.#stationDomainMap) return
		// console.log(`initStationDomainApp`);

		const AppStation = await window.moduleLoader.getStationApp()

		this.#stationDomainMap = new Vue({
			name: "Station Domain Map",
			render: (h) => h(AppStation),
			data: {},
		})
		this.#stationDomainMap.$mount("#station-app")
	}

	async initReviewApp() {
		if (this.#reviewApp) return
		// console.log(`initReviewApp`);

		const AppReview = await window.moduleLoader.getReviewsApp()

		this.#reviewApp = new Vue({
			name: "Review App",
			render: (h) => h(AppReview),
			data: {},
		})
		this.#reviewApp.$mount("#review-app")
	}

	async initTrainBannerApp() {
		this.#trainBanner = new Vue({
			name: "Train Banner App",
			render: (h) => h(TrainBanner),
			data: {},
		})
		this.#trainBanner.$mount("#trainBanner")
	}

	async initClubAdvantagesApp() {
		if (this.#clubAdvantagesApp) return
		const ClubAdvantagesApp = await window.moduleLoader.getClubAdvantagesApp()

		this.#clubAdvantagesApp = new Vue({
			name: "Club Advantages App",
			render: (h) => h(ClubAdvantagesApp),
		})
		this.#clubAdvantagesApp.$mount("#club-advantages-app")
	}

	async initResidenceGalerryApp() {
		if (this.#residenceGallery) return

		this.#residenceGallery = new Vue({
			name: "Residence Gallery App",
			render: (h) => h(ResidenceGallery),
			data: {},
		})
		this.#residenceGallery.$mount("#residence-gallery-app")
	}

	async initAll() {
		await Promise.all([
			this.initPlanningApp(),
			this.initMainMapApp(),
			this.initStationDomainApp(),
			this.initReviewApp(),
			// this.initClubAdvantagesApp(),
		])
	}
}
